/**
 * Maps application route paths to their corresponding module identifiers.
 *
 * Routes NOT in this map (e.g., /profile, /settings, /help) are
 * universally accessible to all authenticated users.
 *
 * Module identifiers must match the values in the `modules` field
 * of the profiles config from authUser_v2.
 */
export const ROUTE_MODULE_MAP: Record<string, string> = {
  "/": "uidashboard",
  "/billing": "uibilling",
  "/table-order": "uitableorder",
  "/supplier-master": "uisupplier",
  "/distributor-master": "uidistmaster",
  "/user-management": "uiuser",
  "/shop-management": "uishops",
  "/scheme-master": "uischememaster",
  "/wob-master": "uiwobmaster",
  "/table-order-config": "uitableorderconfig",
  "/masters": "uimasters",
  "/mass-invoice": "uimassinvoice",
  "/mass-stock-transfer": "uimassstocktransfer",
  "/grn-alcohol": "uigrnalcohol",
  "/grn-nonalcohol": "uigrn-nonalcohol",
  "/grn-return": "uigrnreturn",
  "/grn-nalc-return": "uigrn-nonalcoholreturn",
  "/upload-indent": "uigrn",
  "/inventory": "uiinventory",
  "/stock-transfer": "uistocktransfer",
  "/godown-stock": "uigodownstock",
  "/cash-entry": "uicashentry",
  "/supplier-billpay-req": "uisupplierbillpayreq",
  "/supplier-billpay": "uisupplierbillpay",
  "/purchase-planning": "uipurchaseplanning",
  "/store-expenses": "uistoreexpensesv3",
  "/mass-price-update": "uimasspriceupdate",
  // /mdm/price-update is intentionally NOT in this map — the route's
  // visibility is gated client-side by useIsMdm() (sidebar entry only
  // shows for MDM users) and server-side by accesslevel='mdm' on every
  // /mdm/* endpoint. Adding it here would also require the BE to push
  // a `uimdmpriceupdate` module onto MDM profiles, which it doesn't
  // do today.
  "/selling-price-master": "uisellingpricemaster",
  "/mass-invoice-sales": "uimassinvoicesales",
  "/store-expenses-correction": "uistoreexpensescorrection",
  "/administration": "uiadministration",
  "/control-management": "uicontrolmanagement",
  "/cron-jobs": "uicronjobs",
  "/scripts": "uiscript",
  "/utilities": "uiutilities",
  "/custom-reports": "uicustomreports",
  "/tracker": "uitracker",
  "/transactions": "uitransactions",
  "/total-sales": "uitotalsalesacrossstores",
  "/reports": "uireportsv2",
};
